export const buildShareableExport = (data, trip, privacyConfig) => {
  const tripEvents = (trip.events || []).map(event => {
    const item = { ...event.raw, _source: event.source, _date: event.date };
    if (event.city) item._city = event.city;
    if (event.country) item._country = event.country;
    if (event.venue) item._venue = event.venue;
    return item;
  });

  const manifest = {
    version: '1.0.0',
    exportedAt: new Date().toISOString(),
    privacyEnabled: !!privacyConfig?.enabled,
    trip: {
      title: trip.title,
      mainCity: trip.mainCity,
      mainCountry: trip.mainCountry,
      startDate: trip.startDate,
      endDate: trip.endDate,
    },
    counts: {
      totalEvents: tripEvents.length,
      checkins: trip.sourceCounts?.checkin || 0,
      routes: (trip.sourceCounts?.health || 0) + (trip.sourceCounts?.moves || 0) + (trip.sourceCounts?.google_maps || 0),
      concerts: trip.sourceCounts?.concerts || 0,
    },
    cities: trip.cities || [],
    events: tripEvents,
  };

  return JSON.stringify(manifest, null, 2);
};

export const downloadExport = (json, fileName) => {
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'viagem-export.json';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
